<template>
  <div>
    <BodyLoader :loading="firstLoad"></BodyLoader>
    <div class="dvModals">
      <div id="modal-reassign-team" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Reassign
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Client</label>
                <input v-model="reassignReferral.name" class="browser-default defaultModal-input" readonly type="text" />
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Channel</label>
                <select class="browser-default defaultModal-input" v-model="reassignReferral.channel_id" @change="onChannelChange()">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(channel, index) in defaultChannels" :key="index" :value="channel.id">{{ channel.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Team</label>
                <select class="browser-default defaultModal-input" v-model="reassignReferral.team_id" @change="onTeamChange()">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(team, index) in getTeams(reassignReferral.channel_id)" :key="index" :value="team.id">{{ team.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Member</label>
                <select class="browser-default defaultModal-input" v-model="reassignReferral.user_id">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(user, index) in getUsers(reassignReferral.team_id)" :key="index" :value="user.id">{{ user.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!reassignTeam"
            @click="doReassign()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Reassign
          </a>

          <a
            v-if="reassignTeam"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Reassigning...
          </a>

          <a
            @click="closeModal('modal-reassign-team')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->

      <div id="modal-send-print" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Send Email
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Email Address</label>
                <input v-model="printSendTo" class="browser-default defaultModal-input" placeholder="e.g. juan.delacruz@ayalaland-intl.com" type="text" />
                <div class="defaultModal-helper-text">
                  * Required
                </div>
                <div class="defaultModal-helper-text">
                  Multiple email addresses should be , separated. For ex: j@email.com, m@email.com
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!sendingPrint"
            @click="sendlPrint()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Send
          </a>

          <a
            v-if="sendingPrint"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Sending...
          </a>

          <a
            :disabled="sendingPrint"
            @click="closeModal('modal-send-print')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->
    </div>

    <ReferralNav
      :referralSummary="referralSummary"
      :showAddNew="false"
      @filterByReferralStatus="filterByReferralStatus"></ReferralNav>

    <div class="row dvContent">
      <div class="col s12 dvContentMain">
        <div class="dvSectionTitleOpts">
          <div class="dvSectionTitleOpts-title">
            <span class="icon-fs_referrals"></span>{{ referralStatus }} Referrals
          </div> <!-- dvSectionTitleOpts-title -->
          <div class="dvSectionTitleOpts-options">


            <div
              ref="tippy_sort_menu"
              name="sort-menu1"
              class="waves-effect waves-light btn-Pill sort-menu">
              <div class="label">Sort by</div>
              <div class="dividerVert"></div>
              <span class="detail-dropdown">{{sortTitle}}</span>
              <span class="icon-nav_chevron-down"></span>
            </div> <!-- btn-Pill -->
          </div> <!-- dvSectionTitleOpts-options -->
        </div> <!-- dvSectionTitleOpts -->

        <tippy
         to="sort-menu1"
         placement="bottom"
         offset="[0, 4]"
         interactive
         trigger="click"
         hideOnClick="true"
         theme="light-border"
         arrow="false">
         <div class="sortPopMenuBox-content ">
           <a
            @click="sortBy('latest-referrals', 'Latest Referrals')"
            href="javascript:void(0)" class="sortPopMenuBox-content-item">
             Latest Referrals
           </a>
           <a
            @click="sortBy('oldest-referrals', 'Oldest Referrals')"
            href="javascript:void(0)" class="sortPopMenuBox-content-item">
             Oldest Referrals
           </a>
           <a
            @click="sortBy('a-z', 'Alphabetically (A-Z)')"
            href="javascript:void(0)" class="sortPopMenuBox-content-item">
             Alphabetically (A-Z)
           </a>
           <a
            @click="sortBy('z-a', 'Alphabetically (Z-A)')"
            href="javascript:void(0)" class="sortPopMenuBox-content-item">
             Alphabetically (Z-A)
           </a>
         </div>
       </tippy>



        <div class="dvCards-container">
          <ContentLoader :loading="loading" :firstLoad="firstLoad"></ContentLoader>

          <div
            v-show="noRecordFound && !loading"
            class="dvBlankSection">
            <div class="dvBlankSectionBox flexCenterAll">
              <div class="dvBlankSection-content">
                <div class="dvBlankSection-icon flexCenterAll"><i class="material-icons">find_in_page</i></div>
                <div class="dvBlankSection-text-primary center-align">
                  There are no {{ referralStatus }} referrals to display
                </div>
                <div class="dvBlankSection-text-secondary center-align">
                  Try using the search box above to find what you are looking for.
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="isListType" v-show="!noRecordFound">
            <div class="col s12">
              <div class="dvClientListBox">
                <div class="dvClientListBox-header" v-show="referralStatus != 'archive'">
                  <div class="waves-effect waves-light btn-Pill" @click="toggleAll()">
                    <label>
                      <input
                        type="checkbox"
                        :checked="isCheckedAll()"
                        @click="toggleAll()"
                        class="filled-in defaultCheckbox" /><span></span></label><div class="label">Select All</div>
                  </div>
                  <button class="waves-effect waves-light btn-Pill flexCenterAll"
                    :disabled="selected.length == 0"
                    @click="confirm({
                      id: selected,
                      type: 'archives'
                    })">
                    <span class="icon-action_archive"></span>
                    <div class="label">Archive</div>
                  </button> <!-- btn-Pill -->
                  <button
                    :disabled="selected.length == 0"
                    @click="confirm({
                      id: selected,
                      type: 'extend-referrals'
                    })"
                    v-if="referralStatus=='expiring'"
                    class="waves-effect waves-light btn-Pill flexCenterAll hide-on-small-only">
                    <span class="icon-action_refresh"></span>
                    <div class="label">Extend</div>
                  </button> <!-- btn-Pill -->
                </div><!-- dvClientListBox-header -->
                <div class="dvClientListBox-content">

                  <table class="dvClientList">
                    <tbody>
                      <tr v-for="(referral, index) in referrals" :key="index" :class="{ selected: exists(referral.id, selected) }">
                        <td>
                          <div class="dvClientListItem client-name">
                            <label v-show="referralStatus != 'archive'">
                              <input
                                @click="toggle(referral.id, selected)"
                                :checked="exists(referral.id, selected)"
                                type="checkbox" class="filled-in defaultCheckbox"/><span></span>
                            </label>
                            {{ $store.getters.formatFullName(referral.first_name, referral.last_name) }}
                          </div>
                        </td>
                        <td class="hide-on-med-and-down">
                          <div class="dvClientListItem">
                            <span class="icon-content_email"></span>
                            <a :href="'mailto:'+referral.email">{{ referral.email }}</a>
                          </div>
                        </td>
                        <td class="hide-on-med-and-down">
                          <div class="dvClientListItem" v-show="hasContact(referral)">
                            <span class="icon-content_mobile"></span>
                            <div v-html="displayContactNos(referral)"></div>
                          </div>
                        </td>
                        <td class="hide-on-med-and-down">
                          <div class="dvClientListItem">
                            <span class="icon-content_location"></span>{{ referral.address }}
                          </div>
                        </td>
                        <td>
                          <div class="dvClientListItem" :class="$store.getters.classReferralStatus(referral)">
                            <span class="icon-content_status"></span>{{ $store.getters.submittedAgo(referral) }}
                          </div>
                        </td>
                        <td class="hide-on-small-only" v-if="referralStatus=='pending'">
                          <router-link
                            v-if="referral.pending == 1"
                            :to="{ name:'admin_team_member_resolve', params: { id: referral.referred_by, team_id: referral.team_id, referral_id: referral.pending_from == 0 ? referral.id : referral.pending_from }, query: { from: 'referral' } }"
                            class="waves-effect waves-light  flexCenterAll btn-Pill isResolve">
                            <span class="icon-action_check_circle hide-on-small-only"></span>
                            <div class="label">Resolve</div>
                          </router-link>

                        </td>
                        <td class="hide-on-small-only" v-if="referralStatus=='expiring'">
                          <a
                            v-if="referral.extended_allowed == 1"
                            @click="selectedTeamId = referral.team_id; confirm({
                              id: referral.id,
                              type: 'extend-referral',
                              available_extended: referral.available_extended
                            })"
                            class="waves-effect waves-dark dvCardClient-header-linkRenew flexCenterAll" href="javascript:void(0)"><span class="icon-action_refresh"></span>Extend</a>
                        </td>
                        <td class="client-menu right-align">
                          <a
                            :name="'listview-menu-'+index"
                            :ref="'tippy_menu'+index"
                            class="waves-effect waves-dark btn-Menu-more flexCenterAll" href="javascript:void(0)"><span class="icon-nav_more_horz"></span></a>

                          <tippy
                           v-bind:to="'listview-menu-'+index"
                           placement="left"
                           offset="[10, 2]"
                           interactive
                           arrow
                           trigger="click">
                           <div class="morePopMenuBox-content ">

                             <router-link
                               class="morePopMenuBox-content-item"
                               :to="{ name:'admin_referrals_client_view', params: { id: referral.slug, team_id: referral.team_id } }">
                               <span class="icon-editor_view"></span>View
                             </router-link>

                             <router-link
                               v-if="referral.pending == 1"
                               :to="{ name:'admin_team_member_resolve', params: { id: referral.referred_by, team_id: referral.team_id, referral_id: referral.pending_from == 0 ? referral.id : referral.pending_from }, query: { from: 'referral' } }"
                               class="morePopMenuBox-content-item">
                               <span class="icon-action_check"></span>Resolve
                             </router-link>


                             <a
                              @click="showReassignModal(referral)"
                             href="javascript:void(0)" class="morePopMenuBox-content-item">
                               <i class="material-icons">swap_horiz</i>Reassign
                             </a>



                             <!-- <a href="#" class="morePopMenuBox-content-item">
                               <span class="icon-action_add"></span>Add
                             </a> -->

                             <router-link
                              v-show="referral.archive != 1"
                               class="morePopMenuBox-content-item"
                               :to="{ name:'admin_referrals_update_client', params: { id: referral.slug, team_id: referral.team_id } }">
                               <span class="icon-action_edit"></span>Edit
                             </router-link>

                             <!-- <a href="#" class="morePopMenuBox-content-item">
                               <span class="icon-action_add"></span>Add
                             </a> -->
                             <!-- <a href="#" class="morePopMenuBox-content-item">
                               <span class="icon-action_edit"></span>Edit
                             </a> -->
                             <a
                              v-if="referral.expiring == 1 && referral.extended_allowed == 1"
                              @click="selectedTeamId = referral.team_id; confirm({
                                id: referral.id,
                                type: 'extend-referral',
                                available_extended: referral.available_extended
                              })"
                              href="javascript:void(0)" class="morePopMenuBox-content-item">
                               <span class="icon-action_refresh"></span>Extend
                             </a>

                             <a
                              v-if="$store.getters.forArchive(referral)"
                              @click="selectedTeamId = referral.team_id; confirm({
                                id: referral.id,
                                type: 'archive',
                                client: $store.getters.formatFullName(referral.first_name, referral.last_name)
                              })"
                              href="javascript:void(0)" class="morePopMenuBox-content-item">
                               <span class="icon-action_archive"></span>Archive
                             </a>
                             <!-- <a
                              v-if="referral.pending == 1"
                              href="#" class="morePopMenuBox-content-item">
                               <span class="icon-action_check"></span>Resolve
                             </a>

                             <a href="#" class="morePopMenuBox-content-item">
                               <span class="icon-action_archive"></span>Archive
                             </a> -->
                           </div>
                         </tippy>

                        </td>
                      </tr>

                    </tbody>
                  </table>

                </div> <!-- dvClientListBox-content -->
              </div> <!-- dvClientListBox -->
            </div>
          </div><!-- row -->


          <!-- <template class="row" v-if="!isListType">
            <div class="row" v-for="(chunk, idx) in referralChunks" :key="idx">
              <div class="col s12 m6" v-for="(referral, index) in chunk" :key="index">
                <CardView
                  :referral="referral"
                  :idx="index"
                  @processArchive="processArchive"
                  @extendReferral="extendReferral"
                  @confirm="confirm">
                </CardView>
              </div>
            </div>
          </template> -->



          <!-- <div class="row" v-if="!isListType">
            <div
              v-for="(referral, index) in referrals" :key="index"
              class="col s12 m6">

              <CardView
                :referral="referral"
                :idx="index"
                @processArchive="processArchive"
                @extendReferral="extendReferral"
                @confirm="confirm">
              </CardView>

            </div>
          </div>  -->
        </div> <!-- dvContentMain -->
      </div>


      <div class="col s12 dvContentTools">
        <div class="dvContentTools-fx"></div>
        <div class="dvContentTools-content">
          <a
            :class="{ disabled: (pager.currentPage < 2 || loading) ? true : false }"
            @click="previousPage()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">
            <span class="icon-nav_chevron_left"></span>Previous
          </a>
<!--  -->
          <div class="dvContentTools-pagination">
            <form id="frmChangePassword" @submit.prevent="setPage">
              <input
                type="text" class="browser-default" v-model="pager.currentPage" />
            </form>
            <div class="dvContentTools-pagination-label">of {{ pager.totalPages }}</div>
            <!-- <div class="dvContentTools-pagination-label">{{ pager.dataStart }} of {{ pager.totalRecords }}</div> -->
          </div>

          <a
            :class="{ disabled: !pager.hasNext || loading }"
            @click="nextPage()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">
            Next<span class="icon-nav_chevron_right"></span>
          </a>
        </div>
        <div class="dvContentTools-page">
          <a @click="emailPrint('modal-send-print')" href="javascript:void(0)" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-content_email"></span><div class="hide-on-small-only">Email</div></a>
          <a @click="printJS()" href="javascript:void(0)" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_print"></span><div class="hide-on-small-only">Print</div></a>
          <ToTop></ToTop>
        </div>

      </div>



      <div id="userPopMenuBox">
        <div class="userPopMenuBox-content ">
          <a href="#" class="userPopMenuBox-content-item">
            <span class="icon-editor_list"></span>My Activity
          </a>
          <a href="#" class="userPopMenuBox-content-item">
            <span class="icon-action_logoff"></span>Logout
          </a>
        </div>
      </div> <!-- userPopMenuBox -->


    </div> <!-- dvContent -->

    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    <ConfirmationDialog
      :dialog="dialog"
      @doConfirm="doConfirm">
    </ConfirmationDialog>
  </div>
</template>

<style>
.sort-menu:focus {
  outline: 0px !important;
  -webkit-appearance: none;
  box-shadow: none !important
}
</style>

<script>
  import ReferralNav from './ReferralNav.vue'
  // import CardView from '@/components/referral_view/ClientCardView.vue'
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ConfirmationDialog from '@/components/confirmation_view/ConfirmationDialog.vue'
  import { tippy } from "vue-tippy"
  import _ from 'lodash'
  import BodyLoader from '@/components/BodyLoader.vue'
  import ContentLoader from '@/components/ContentLoader.vue'
  import printJS from 'print-js'
  import M from 'materialize-css'
  import ToTop from '@/components/totop/ToTop.vue'

  export default {
    name: 'referrals-main',
    data: () => ({
      printSendTo: '',
      sendingPrint: false,
      dialog: {
        show: false,
        title: '',
        body: '',
        action: '',
        id: ''
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      selectedTeamId: '',
      sortTitle: 'Latest Referrals',
      isListType: true,
      loading: false,
      archiving: false,
      extending: false,
      noRecordFound: false,
      selected: [],
      selectToggele: false,
      referrals: [],
      referralStatus: 'valid',
      referralSummary: {
        pending: '',
        valid: '',
        expiring: '',
        archive: ''
      },
      defaultTeams: [],
      defaultChannels: [],
      defaultUsers: [],
      reassignTeam: false,
      reassignReferral: {
        id: '',
        name: '',
        team_id: '',
        channel_id: '',
        user_id: ''
      },
      pager: {
        currentPage: 1,
        perPage: 10,
        hasNext: 0,
        totalRecords: 0,
        totalPages: 0,
        dataStart: 0
      },
      sortPopMenuBox: '',
      orderBy: '',
      firstLoad: true,
      clickedFromSubNav: false,
      domain: '',
    }),
    watch:{
      $route (to, from){
        let param = from.params.status

        if(to.name == 'referral_status' && !this.clickedFromSubNav && to.params.status=='valid' && from.params.status != 'valid'){
          this.filterByReferralStatus('valid')
        }

        this.clickedFromSubNav = false
      }
    },
    computed: {
      referralChunks(){
          return _.chunk(Object.values(this.referrals), 2);
      }
    },
    methods: {
      onChannelChange (){
        this.reassignReferral.team_id = ''
        this.reassignReferral.user_id = ''
      },
      onTeamChange (){
        this.reassignReferral.user_id = ''
      },
      getTeams (channel_id){
        let teams = this.defaultTeams.filter(team => {
          return team.channel_id == channel_id
        })
        return teams
      },
      getUsers (team_id){
        let users = this.defaultUsers.filter(user => {
          return user.team_id == team_id
        })
        return users
      },
      doReassign () {
        if(this.reassignReferral.team_id == ''){
          this.showMessage('The team field is required.', 'sb-failed')
          return false
        }

        if(this.reassignReferral.channel_id == ''){
          this.showMessage('The channel field is required.', 'sb-failed')
          return false
        }

        if(this.reassignReferral.user_id == ''){
          this.showMessage('The member field is required.', 'sb-failed')
          return false
        }

        if(this.reassignTeam){
          return false;
        }
        this.reassignTeam = true
        let self = this

        this.$http.secured.post('/api/referrals/reassign/'+ this.reassignReferral.id + '/' + this.reassignReferral.user_id)
          .then(response => {
            this.getLatestReferrals()
            this.showMessage(response.data.message, 'sb-success')
            this.closeModal('modal-reassign-team')
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.reassignTeam = false
          })
      },
      showReassignModal (referral) {
        let reassignReferral = {
          id: referral.id,
          name: this.$store.getters.formatFullName(referral.first_name, referral.last_name),
          team_id: referral.team_id,
          channel_id: referral.channel_id,
          user_id: referral.referred_by
        }

        this.reassignReferral = reassignReferral
        this.openModalTeam('modal-reassign-team')
      },
      openModalTeam (str){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
      },
      printJS (){

        let url = this.domain+'/api/referrals?referral_type='+this.referralStatus+'&request_type=print'
        if(this.orderBy.length > 0){
          url += '&order_type=' + this.orderBy
        }
        printJS(url);
      },
      closeModal (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.close();

        this.printSendTo = ''
      },
      emailPrint (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
      },
      sendlPrint (){
        if(this.printSendTo == ''){
          this.showMessage('The email field is required.', 'sb-failed')
          return false
        }

        if(this.sendingPrint){
          return false
        }

        let self = this
        self.sendingPrint = true

        let url = '/api/referrals?referral_type='+this.referralStatus+'&request_type=mail&send_to='+this.printSendTo
        this.$http.plain.get(url)
          .then(response => {
            if(response.data == 'sent'){
              this.showMessage('Email has been sent', 'sb-success')
            }
            this.printSendTo = ''
            this.closeModal('modal-send-print')
          })
          .catch(error => {
            if (error.response.status === 500) {
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }else{
              this.showMessage(error.response.data.messages.error, 'sb-failed')
            }
          })
          .then(function () {
            self.sendingPrint = false
          })
      },
      toggleAll: function() {
        if (this.selected.length === this.referrals.length) {
          this.selected = [];
        } else if (this.selected.length === 0 || this.selected.length > 0) {
          this.selected = [];

          this.referrals.forEach((value) => {
              this.selected.push(value.id);
          });
        }
      },
      isIndeterminate: function() {
        return (this.selected.length !== 0 && this.selected.length !== this.referrals.length)
      },
      isChecked: function() {
        return this.selected.length === this.referrals.length
      },
      exists: function(item, list) {
        return list.indexOf(item) > -1
      },
      toggle: function(item, list) {
        var idx = list.indexOf(item)
        if (idx > -1) {
          list.splice(idx, 1)
        }
        else {
          list.push(item)
        }
      },
      isCheckedAll: function(){
        if (this.referrals.length === 0){
          return false
        }
        return this.selected.length === this.referrals.length
      },
      setExpiringView (){
        // if(this.referralStatus == 'expiring'){
        //   this.isListType = true
        // }else{
        //   this.isListType = false
        // }
      },
      switchView (){
        this.isListType = !this.isListType
      },
      hasContact: function(referral){
        return this.displayContactNos(referral) == '' ? false : true
      },
      displayContactNos: function(referral) {
        let mobTels = [];
        if(referral.mobile_no.length > 0){
          mobTels.push('<a href="tel:'+referral.mobile_no+'">'+referral.mobile_no+'</a>')
        }
        if(referral.phone_no.length > 0){
          mobTels.push('<a href="tel:'+referral.phone_no+'">'+referral.phone_no+'</a>')
        }

        return mobTels.join(', ')
      },
      filterByReferralStatus (filerStatus) {
        this.clickedFromSubNav = true
        this.$router.push({ name: 'admin_referral_status', params: { status: filerStatus } })
        this.referralStatus = filerStatus
        this.selected = [];
        this.setExpiringView()
        this.pager.currentPage = 1
        this.getLatestReferrals()
      },
      setPage (){
        if(this.pager.currentPage > this.pager.totalPages || this.pager.currentPage < 1){
          this.pager.currentPage = 1
        }

        this.getLatestReferrals();
      },
      previousPage (){
        window.scroll(0, 0)
        this.pager.currentPage--;
        this.getLatestReferrals();
      },
      nextPage (){
        window.scroll(0, 0)
        this.pager.currentPage++;
        this.getLatestReferrals();
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      confirm (action){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        if(action.type == 'archive'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to archive '+action.client+'?',
            body: 'You can\'t undo this action.',
            icon: 'icon-action_archive',
            positionBtn: 'Archive',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type== 'extend-referral'){
          this.dialog = {
            show: true,
            title: 'Do you want to extend referral?',
            body: 'You have '+action.available_extended+' extension/s left',
            icon: 'icon-action_refresh',
            positionBtn: 'Extend',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type== 'extend-referrals'){
          this.dialog = {
            show: true,
            title: 'Do you want to extend referrals?',
            body: 'Extend all selected referrals?',
            icon: 'icon-action_refresh',
            positionBtn: 'Extend',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type == 'archives'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to archive all selected clients?',
            body: 'You can\'t undo this action.',
            icon: 'icon-action_archive',
            positionBtn: 'Archive',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }

      },
      doConfirm (){
        this.dialog.show = false

        if(this.dialog.actionType == 'archive'){
          this.processArchive(this.dialog.id)
        }else if(this.dialog.actionType == 'extend-referral'){
          this.extendReferral(this.dialog.id)
        }else if(this.dialog.actionType == 'extend-referrals'){
          this.extendReferrals()
        }else if(this.dialog.actionType == 'archives'){
          this.archiveSelected()
        }
      },
      processArchives (ids) {
        if(this.archiving){
          return false;
        }
        this.archiving = true
        let self = this

        this.$http.secured.post('api/referrals/archive/'+ ids+ '?team_id='+this.selectedTeamId)
          .then(response => {
            this.selectedTeamId = ''
            this.getLatestReferrals()
            this.showMessage(response.data.message, 'sb-success')
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.archiving = false
          })
      },
      processArchive (id) {
        this.processArchives(id)
      },
      archiveSelected (){
        if(this.selected.length == 0){
          this.showMessage('No selected referrals', 'sb-default')
          return false;
        }

        this.processArchives(this.selected)
      },
      extendReferral (id){
        this.processExtendReferrals(id)
      },
      processExtendReferrals (ids){
        if(this.extending){
          return false;
        }

        this.extending = true
        let self = this

        this.$http.secured.post('api/referrals/extend/'+ ids+ '?team_id='+this.selectedTeamId)
          .then(response => {
            this.selectedTeamId = ''
            this.getLatestReferrals()
            this.showMessage(response.data.message, 'sb-success')
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.messages.error, 'sb-failed')
            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.extending = false
            self.selected = []
          })
      },
      extendReferrals (){
        if(this.selected.length == 0){
          this.showMessage('No selected referrals', 'sb-default')
          return false;
        }

        this.processExtendReferrals(this.selected)
      },
      extendSelectedReferral (){
        if(this.selected.length == 0){
          this.showMessage('No selected referrals', 'sb-default')
          return false;
        }

      },
      sortBy (orderBy, sortTitle){
        let el = this.$refs['tippy_sort_menu'];
                if (el && el._tippy) {
                    el._tippy.hide()
                }
        this.sortTitle = sortTitle
        this.orderBy = orderBy;
        this.getLatestReferrals()
      },
      getLatestReferrals () {
        if(this.loading){
          return false;
        }

        let self = this
        this.loading = true
        this.noRecordFound = false
        this.selected = [];
        this.referrals = [];
        let url = 'api/referrals?referral_type='+this.referralStatus+'&page='+this.pager.currentPage+'&per_page='+this.pager.perPage

        if(this.orderBy.length > 0){
          url += '&order_type=' + this.orderBy
        }

        this.$http.plain.get(url)
          .then(response => {

            this.referrals = response.data.referrals;
            this.referralSummary = response.data.referral_summary

            if(this.referrals.length == 0){
              this.noRecordFound = true
            }

            this.pager.hasNext = response.data.pager.has_next_page
            this.pager.totalRecords = response.data.pager.total_records
            this.pager.dataStart = response.data.pager.data_start
            this.pager.totalPages = response.data.pager.total_pages
            // document.getElementById("toFocus").focus();
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.loading = false
            self.firstLoad = false
          })
        },
        getDefaultData () {
          this.$http.plain.get('api/default-data')
            .then(response => {
              this.defaultChannels = response.data.channels
              this.defaultTeams = response.data.teams
              this.defaultUsers = response.data.users
            })
            .catch(error => {
              console.log(error);
            })
        }
    },
    mounted() {
      this.domain = this.$store.getters.getApiURL
      this.referralStatus = this.$route.params.status
      this.setExpiringView()
      this.getLatestReferrals()
      this.getDefaultData()

      this.sortPopMenuBox = document.getElementById('sortPopMenuBox');

      if(this.$route.query.added){
        if(this.$route.params.status == 'pending'){
          this.showMessage(this.$route.query.msg, 'sb-pending')
        }else{
          this.showMessage(this.$route.query.msg, 'sb-success')
        }
        this.$router.push({ name: 'admin_referral_status', params: { status: this.$route.params.status } })
      }

      if(this.$route.query.resolved){
        this.showMessage(this.$route.query.msg, 'sb-success')
      }

    },
    components: {
      ReferralNav,
      // CardView,
      SnackBar,
      ConfirmationDialog,
      BodyLoader,
      ContentLoader,
      ToTop
    }
  }
</script>
